export default __webpack_public_path__ + "static/media/Icon awesome-question.3df9cbbc.svg";